import { render, staticRenderFns } from "./ModuleAttachmentSlidebar.vue?vue&type=template&id=4965323e"
import script from "./ModuleAttachmentSlidebar.vue?vue&type=script&lang=js"
export * from "./ModuleAttachmentSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports